<template>
  <div
    class="bto-sb-mormarket-content bto-sb-event-mormarket-full bto-sb-event-market-player"
    :class="{ 'bto-sb-event-market-3w': !isWincastMarket(group) }">
    <div class="bto-sb-event-mormarket-market">
      <component
        :is="isWincastMarket(group) ? 'div' : 'empty-component'"
        class="bto-sb-event-mormarket-market-outrights-single bto-sb-event-mormarket-wincast">
        <div
          class="bto-sb-event-mormarket-market-name bto-sb-mormarket-name bto-sb-bar-filter"
          :class="{ 'bto-sb-event-market-cashout ': group.hasCashout }">
          <i class="bto-app-cash" v-if="group.hasCashout"></i>
          <h4>{{ group.name }}</h4>
          <div class="bto-sb-player-team-legend" v-show="SHOW_TEAM_JERSEYS">
            <span
              ><span class="bto-sb-player-team-jersey bto-sb-player-home"></span
              >{{ match.homeTeam }}</span
            >
            <span
              ><span class="bto-sb-player-team-jersey bto-sb-player-away"></span
              >{{ match.guestTeam }}</span
            >
          </div>
        </div>
        <template v-if="!isWincastMarket(group)">
          <div
            class="bto-sb-event-mormarket-market-odd"
            v-for="(row, i) in playersRow(market)"
            :key="i">
            <span class="bto-sb-event-odd" v-for="(outcome, j) in row" :key="j">
              <component
                :is="match.isLiveMatch ? 'match-odd-live-details-component' : 'match-odd-component'"
                :match="match"
                :odd="market"
                :outcome="outcome || { outcome: '--' }"
                :isDetails="true"
                :lockEmptyOdd="false"
                :isPlayerMarket="true"
                :showTeamJerseys="SHOW_TEAM_JERSEYS"
                :showPlayerTeamName="SHOW_PLAYER_TEAM_NAME"
                :playerTeamName="playerTeam(outcome)"
                :showEmptyOutcome="true"/>
            </span>
          </div>
        </template>
        <template v-if="isWincastMarket(group)">
          <div class="bto-sb-event-mormarket-cols">
            <div class="bto-sb-event-mormarket-col" v-for="num in 3" :key="num">
              <div
                class="bto-sb-event-mormarket-market-odd"
                v-for="(outcome, idx) in getWincastMarketsColumn(market, num)"
                :key="idx">
                <span>
                  {{ outcome.name }}
                </span>
                <span>
                  <component
                    :is="match.isLiveMatch ? 'match-odd-live-details-component' : 'match-odd-component'"
                    :match="match"
                    :odd="market"
                    :outcome="outcome || { outcome: '--' }"
                    :isDetails="true"
                    :lockEmptyOdd="false"
                    :isWincast="true" />
                </span>
              </div>
            </div>
          </div>
        </template>
        <div class="bto-sb-widget-footer" v-if="showMoreButton">
          <a
            href="javascript:void(0)"
            class="bto-sb-more-item"
            :class="{ 'bto-sb-show': !showAll, 'bto-sb-less': showAll }"
            @click="toggleRows">
            {{ t(showAll ? "Mobile.ShowLess" : "Mobile.ShowMore") }}
          </a>
        </div>
      </component>
    </div>
  </div>
</template>

<script>
import { EmptyComponent } from '@bto-widgets/utils/shared';
import MatchOddLiveDetailsComponent from '../../../common/match/match-odd-live-details-component.vue';

export default {
  name: "SinglePlayerMarketComponent",
  components: {
    EmptyComponent,
    MatchOddLiveDetailsComponent
  },
  data() {
    return {
      OUTCOME_ROWS_DEFAULT: +APP_SETTINGS.settings.outcomesToShowByDefault,
      showAll: false,
      SHOW_TEAM_JERSEYS: APP_SETTINGS.playerOdds.showTeamJerseys,
      SHOW_PLAYER_TEAM_NAME: APP_SETTINGS.playerOdds.showPlayerTeamName,
    };
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    match: {
      type: Object,
      required: true,
    },
    market: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showMoreButton() {
      if (!this.OUTCOME_ROWS_DEFAULT) {
        return false;
      }
      const firstRowList = this.isWincastMarket(this.group) ? this.getWincastMarketsColumn(this.market, 1, true) : this.playersRow(this.market, true);
      return firstRowList.length > this.OUTCOME_ROWS_DEFAULT;
    },
  },
  methods: {
    playerTeamJersey(player) {
      return player.teamEnum === 1 ? "bto-sb-player-home" : "bto-sb-player-away";
    },
    playerTeam(player) {
      if (!player.teamEnum || !this.match) {
        return "";
      }
      return player.teamEnum === 1 ? this.match.homeTeam : this.match.guestTeam;
    },
    playersRow(market, getAll) {
      const outcomes = this.sliceIntoChunks(market.outcomes, 3);
      const outcomeSlice = (!getAll && !this.showAll && this.OUTCOME_ROWS_DEFAULT) || Infinity;
      return outcomes.slice(0, outcomeSlice);
    },
    getWincastMarketsColumn(market, num, getAll) {
      const outcomes = market.outcomes || [];
      const outcomeSlice = (!getAll && !this.showAll && this.OUTCOME_ROWS_DEFAULT) || Infinity;
      return outcomes.filter(
        (_, idx) => idx % 3 === (num - 1) % 3
      ).slice(0, outcomeSlice);
    },
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
    toggleRows() {
      this.showAll = !this.showAll;
    },
    isWincastMarket(group) {
      if (!group.simpleMarkets[0] || !group.simpleMarkets[0].outcomeLayout) {
        return false;
      }
      return group.simpleMarkets[0].outcomeLayout === 'single_column';
    },
  },
};
</script>